import useGenerateColumns from "@/common/hooks/useGenerateColumns";
import { ColumnsStrategy } from "@/common/types";
import { cn } from "@/common/utils";
import Table from "antd/es/table/Table";

export default function BaseTable({
  strategy,
  data,
  onRowClick,
  rowClassName,
  tableClassName,
  from,
  rootClassName,
  scrollY,
}: {
  strategy: ColumnsStrategy[];
  data: Record<string, any>[] | undefined;
  onRowClick?: (record: unknown) => void;
  rowClassName?: (record: unknown) => string;
  tableClassName?: string;
  rootClassName?: string;
  from?: string;
  scrollY?: number;
}) {
  const columns = useGenerateColumns({ strategy });

  return (
    <>
      <Table
        tableLayout="fixed"
        scroll={{ x: true, y: scrollY }}
        columns={columns}
        dataSource={data}
        pagination={false}
        className={cn("", tableClassName)}
        rootClassName={cn("", rootClassName)}
        rowClassName={
          typeof rowClassName !== "undefined"
            ? (record) => rowClassName(record)
            : ""
        }
        onRow={(record) => {
          return {
            onClick: () => onRowClick && onRowClick(record),
          };
        }}
        key={JSON.stringify(from)}
        rowKey={(record) => record.id}
      />
    </>
  );
}
